import { Modal } from "react-bootstrap";
import DetailFile from "../DetailFile/DetailFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";
import { statusAudio } from "../../pages/visualizar-archivos/Main";

export default function ModalDetailFile({ stateShow, archivo, title, textSearch, hookStateAudio }: { stateShow: Array<any>; archivo?: any; title?: boolean; textSearch?: string; hookStateAudio: [statusAudio, Function] }) {
    return (
        <Modal show={stateShow[0]} onHide={() => stateShow[1](false)} size="xl" centered scrollable={false} fullscreen keyboard>
            <div className="bg-primary text-white ">
                <Row className="d-flex flex-row mx-4 my-2">
                    <Col className="d-flex justify-conten-start" xl={10} lg={10} md={10} sm={10}>
                        <div>
                            <img src="/images/LogoNegro.svg" width="110" alt="app-logo" />
                        </div>
                        <div className="mx-5 d-flex justify-content-start my-auto  ">
                            <div>
                                {archivo?.jurisprudence ? (
                                    <div className="text-start">
                                        <h4>{archivo?.jurisprudence}</h4>
                                    </div>
                                ) : (
                                    <div className="d-flex flex-column justify-content-around align-items-start text-start ">
                                        <span className="h3 text-start">
                                            {archivo?.tag !== "65846bec7f2c7be3ada5ba6c" && (
                                                <>
                                                    <span>TIPO DE FOLDER:</span>
                                                    <span>{` ${archivo?.folderType || ""} `}</span>
                                                </>
                                            )}
                                        </span>
                                        <span>
                                            <span className="h3">
                                                {archivo?.tag === "ACUERDO" ? "ACUERDO:" : archivo?.tag === "JURISPRUDENCIA" ? "JURISPRUDENCIA:" : "EXPEDIENTE:"}
                                                {` ${archivo?.number || ""} / ${archivo?.year || ""}`}
                                            </span>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col className="d-flex justify-content-end" xl={2} lg={2} md={2} sm={2}>
                        <div>
                            <FontAwesomeIcon
                                icon={faXmark}
                                size="2xl"
                                onClick={() => {
                                    stateShow[1](false);
                                }}
                                style={{ cursor: "pointer" }}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="pt-0 bg-body">{archivo && <DetailFile archivo={archivo} textSearch={textSearch} hookStateAudio={hookStateAudio} />}</div>
        </Modal>
    );
}
